import { DateRangeField, DecoratedFormUnit } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { useTimezone } from '../../../../../../core/hooks';
import { AuditStationsSelect } from '../../../../components/AuditStationsSelect';

export const ConsecutiveSchedulesReportForm = () => {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <div>
      <div className="row">
        <div className="col-4">
          <DecoratedFormUnit
            label={$t({
              id: 'common.datetimeRange',
              defaultMessage: 'Rango de fecha y hora',
            })}
          >
            <DateRangeField name={['from', 'to']} tz={tz} />
          </DecoratedFormUnit>
        </div>
      </div>
      <div className="row">
        <div className="col-9">
          <AuditStationsSelect multiple maxSelected={10} />
        </div>
      </div>
    </div>
  );
};
